"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.UC_CLOUD = exports.LYRA_SPACE = exports.DEFAULT_PRODUCT_NAME = void 0;
var LYRA_SPACE = 'LYRA_SPACE';
exports.LYRA_SPACE = LYRA_SPACE;
var UC_CLOUD = 'uc-cloud';
exports.UC_CLOUD = UC_CLOUD;
var DEFAULT_PRODUCT_NAME = 'default';
exports.DEFAULT_PRODUCT_NAME = DEFAULT_PRODUCT_NAME;
//# sourceMappingURL=constants.js.map
